import { FALLBACK_CURRENCY } from './constants';

const CURRENCY_CODE = /^[A-Z]{3}$/;

let knownCurrencies: ReadonlySet<string> | null | undefined;

// Intl.NumberFormat accepts any three letters, so a casino code like "GCS"
// would pass for money; the runtime's own currency list does not. Browsers
// without supportedValuesOf fall back to the format check alone.
function supportedCurrencies(): ReadonlySet<string> | null {
  if (knownCurrencies === undefined) {
    knownCurrencies =
      typeof Intl.supportedValuesOf === 'function' ? new Set(Intl.supportedValuesOf('currency')) : null;
  }
  return knownCurrencies;
}

export function isIsoCurrencyCode(code: string): boolean {
  if (!CURRENCY_CODE.test(code)) return false;
  return supportedCurrencies()?.has(code) ?? true;
}

/** ISO operator currency → itself; otherwise the partner's override when it is
 *  a real currency, else USD. */
export function resolveTrackingCurrency(operatorCurrency: string | null, override: string | null): string {
  if (operatorCurrency !== null && isIsoCurrencyCode(operatorCurrency)) return operatorCurrency;
  if (override !== null && isIsoCurrencyCode(override)) return override;
  return FALLBACK_CURRENCY;
}
